// @flow

import {
  API_LOGIN_SUCCESS,
  API_LOGIN_FAILURE,
  API_LOGIN_LOADING,
  API_FORGOT_SUCCESS,
  API_FORGOT_FAILURE,
  API_FORGOT_LOADING,
  API_RESET_SUCCESS,
  API_RESET_FAILURE,
  API_RESET_LOADING,
  API_UPDATEUSER_SUCCESS,
  API_UPDATEUSER_FAILURE,
  API_UPDATEUSER_LOADING
} from '../actions/constants';

const initialState = {
  isLoading: false,
  hasFailed: false,
  data: {},
  loginSuccess: false,
  forgot: { forgotSuccess: false, hasFailed: false, errorMessage: {}, forgotLoading: false },
  reset: { resetSuccess: false, hasFailed: false, errorMessage: {}, resetLoading: false },
  updateUser: { updateUserSuccess: false, hasFailed: false, errorMessage: {}, updateUserLoading: false }
};

export default function(state = initialState, action: Object) {
  switch (action.type) {
    case API_LOGIN_LOADING:
      return { ...state, isLoading: action.isLoading };
    case API_LOGIN_SUCCESS:
      return { ...state, data: action.data, loginSuccess: true };
    case API_LOGIN_FAILURE:
      return { ...state, hasFailed: action.hasFailed, data: action.data };
    case API_FORGOT_LOADING:
      return { ...state, forgot: { ...state.forgot, forgotLoading: action.isLoading } };
    case API_FORGOT_SUCCESS:
      return { ...state, forgot: { ...state.forgot, forgotSuccess: true, hasFailed: false } };
    case API_FORGOT_FAILURE:
      return {
        ...state,
        forgot: { ...state.forgot, forgotSuccess: false, hasFailed: true, errorMessage: action.data }
      };
    case API_RESET_LOADING:
      return { ...state, reset: { ...state.reset, resetLoading: action.isLoading } };
    case API_RESET_SUCCESS:
      return { ...state, reset: { ...state.reset, resetSuccess: true, hasFailed: false } };
    case API_RESET_FAILURE:
      return { ...state, reset: { ...state.reset, resetSuccess: false, hasFailed: true, errorMessage: action.data } };
    case API_UPDATEUSER_LOADING:
      return { ...state, updateUser: { ...state.updateUser, updateUserLoading: action.isLoading } };
    case API_UPDATEUSER_SUCCESS:
      return { ...state, updateUser: { ...state.updateUser, updateUserSuccess: true, hasFailed: false } };
    case API_UPDATEUSER_FAILURE:
      return {
        ...state,
        updateUser: { ...state.updateUser, updateUserSuccess: false, hasFailed: true, errorMessage: action.data }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/login_reducer.js